module.exports = {
	"header": "Request Condition Report",
	"descriptionLabel": "The dealer will provide a written condition report for this item. If you have any specific questions regarding condition that you would like the report to address, please include them below.",
	"error": "This field is required.",
	"buttonSend": "Send",
	"buttonSending": "Sending...",
	"makeOfferLinkPrompt": "Ready to negotiate? ",
	"makeOfferLinkCta": "Make an offer >",
	"successHeader": "Request Sent",
	"successMessage": "You will receive a written condition report via email within two business days. If you require any assistance in the meantime, please contact Trade Concierge Services at <a href=\"mailto:trade@1stdibs.com\">trade@1stdibs.com</a> or 646-454-2651."
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/contact/dealer/components/conditionReportModalCopy.json
// module id = 2013
// module chunks = 4